import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";
import { EditGridColumnType } from "../../../../../components/FinalMolGrid/libs/data/editGridColumnType";
import { GridColumnType } from "../../../../../data/gridColumnType";

const initState = {
  planningTitle: "",
  startDate: "",
  endDate: "",
  workingDays: "",
};

export const teamPlanning = {
  name: "Team Planning Form",
  initialState: initState,

  section: [
    {
      sectionId: "TeamPlanning",
      title: "Team Planning Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "planningTitle",
          label: "Planning Title",
          Field_Name: "Planning Title",
          fieldType: FormFieldTypes.INPUT,
          dataField: "planningTitle",
          fieldSetting: {
            placeholder: "Please Enter Planning Title",
            allowSpace: true,
            maxLength: 100
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2",
          },
        },
        {
          id: "startDate",
          label: "Start Date",
          Field_Name: "start date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "startDate",
          fieldSetting: {
            placeholder: "Please Select Start Date",
            allowSpace: true,
            dateConfig: {
              dateFormat: "DD/MM/YYYY",
            },
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2",
          },
        },

        {
          id: "endDate",
          label: "End Date",
          Field_Name: "end date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "endDate",
          fieldSetting: {
            placeholder: "Please Select End Date",
            dateConfig: {
              dateFormat: "DD/MM/YYYY",
            },
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2",
          },
        },

        {
          id: "workingDays",
          label: "Total Working Days",
          Field_Name: "total working days",
          fieldType: FormFieldTypes.NUMERIC,
          dataField: "workingDays",
          fieldSetting: {
            placeholder: "Please Enter Total Working Days",
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2",
          },
        },
      ],
    },
  ],
};

// formFields: [
// {
//   id: "startDate",
//   label: "Start Date",
//   Field_Name: "Start Date",
//   fieldType: FormFieldTypes.DATEPICKER,
//   dataField: "startDate",
//   fieldSetting: {
//     placeholder: "Enter Start Date",
//   },
//   validation: [{ type: validationTypes.REQUIRE }],
//   style: {
//     containerCss: "col-lg-6 col-md-6 mb-2",
//   },
// },

// {
//   id: "endDate",
//   label: "End Date",
//   Field_Name: "End Date",
//   fieldType: FormFieldTypes.DATEPICKER,
//   dataField: "endDate",
//   fieldSetting: {
//     placeholder: "Enter End Date",
//   },
//   validation: [{ type: validationTypes.REQUIRE }],
//   style: {
//     containerCss: "col-lg-6 col-md-6 mb-2",
//   },
// },

// {
//   id: "workingDays",
//   label: "Total Working Days",
//   Field_Name: "Total Working Days",
//   fieldType: FormFieldTypes.NUMERIC,
//   dataField: "workingDays",
//   fieldSetting: {
//     placeholder: "Total Working Days",
//   },
//   validation: [{ type: validationTypes.REQUIRE }],
//   style: {
//     containerCss: "col-lg-6 col-md-6 mb-2",
//   },
// },
// ],

export const TeamPlanningGridConfig = {
  columns: [
    {
      name: "Start Date",
      fieldName: "startDate",
      allowShort: false,
      allowEditColumn: true,
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD/MM/YYYY",
      },
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
      editColumn: {
        editColType: EditGridColumnType.DATEPICKER,
        placeholder: "Please Select Start Date",
        editColFieldName: "startDate",
        isDisable: false,
        colConfig: {
          isReadOnly: false,
        },
        editColValidation: [
          { type: "required", message: "StartDate  is required." },
        ],
      },
    },
    {
      name: "End Date",
      fieldName: "endDate",
      allowShort: false,
      allowEditColumn: true,
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD/MM/YYYY",
      },
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
      editColumn: {
        editColType: EditGridColumnType.DATEPICKER,
        placeholder: "Please Select End Date",
        editColFieldName: "endDate",
        isDisable: false,
        colConfig: {
          isReadOnly: false,
        },
        editColValidation: [
          { type: "required", message: "EndDate  is required." },
        ],
      },
    },
    {
      name: "Working Days",
      fieldName: "workingDays",
      allowShort: false,
      allowEditColumn: true,
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
      editColumn: {
        editColType: EditGridColumnType.NUMERIC,
        placeholder: "Please Enter Working Days",
        editColFieldName: "workingDays",
        isDisable: false,
        colConfig: {
          isReadOnly: false,
        },
        editColValidation: [
          { type: "required", message: "WorkingDays  is required." },
        ],
      },
    },
    {
      name: "Planning Status",
      fieldName: "statusName",
      allowShort: false,
      allowEditColumn: false,
      colType: GridColumnType.LABEL,
      colSettings: {
        // getLableClass: (value) => {
        //   const displayVal = value?.toString().toLowerCase();
        //   switch (displayVal) {
        //     case "1":
        //       return "Ongoing";
        //     case "2":
        //       return "Completed";
        //     case "3":
        //       return "Upcoming";
        //   }
        // },
      },
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: true,
      },
      customAction: [
        {
          name: "NEXT",
          iconClass: "streamline:next",
        },
      ],
      colStyle: {
        width: "150px",
        textAlign: "center",
      },
      allowShort: false,
    },
  ],
  editSettings: {
    buttons: {
      save: true,
      cancel: true,
    },
  },
  allowEdit: true,
  handleRowDataUpdate: null,
  OnColumnChangeEdit: null,
  hasChildGridTable: false,
};
